import { get } from '@classic/Foundation/Services/ApiService'
import { CognitoUser } from '@mobi/api-types'
import { QueryClient, useQuery } from '@tanstack/react-query'

let lastUsedAccountNumber: number | undefined

export function cognitoUserQueryKey(accountNumber?: number) {
  return ['cognitoUser', accountNumber ?? lastUsedAccountNumber]
}

export function invalidateCognitoUserQuery(queryClient: QueryClient, accountNumber?: number) {
  queryClient.invalidateQueries({ queryKey: cognitoUserQueryKey(accountNumber) })
}

export async function invalidateCognitoUserQueryAsync(
  queryClient: QueryClient,
  accountNumber?: number
) {
  await queryClient.refetchQueries({ queryKey: cognitoUserQueryKey(accountNumber) })
}

export function useCognitoUser(
  accountNumber: number,
  options: { enabled: boolean } = { enabled: true }
) {
  lastUsedAccountNumber = accountNumber
  return useQuery<CognitoUser>({
    queryKey: cognitoUserQueryKey(accountNumber),
    queryFn: fetchCurrentCognitoUser,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
    enabled: options.enabled,
  })
}

export function fetchCurrentCognitoUser() {
  return get<CognitoUser>({
    url: '/api/mfa/get-auth-contact-details',
  })
}
